import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Package, Clock } from 'lucide-react';
export function Delivery() {
  return <section className="py-24 bg-brand-cream" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-134">
            Інформація про доставку
          </h2>
          <p className="text-brand-dark/70 max-w-2xl mx-auto" data-id="element-135">
            Ми дбаємо про те, щоб ваші речі прибули безпечно та вчасно.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-136">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-137">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-138">
              <Truck className="w-8 h-8 text-brand-burgundy" data-id="element-139" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-140">
              Нова Пошта
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-141">
              Швидка та надійна доставка по Україні до найближчого відділення
              або поштомату.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-142">
              1-3 Робочі дні
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-143">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-144">
              <Package className="w-8 h-8 text-brand-burgundy" data-id="element-145" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-146">
              Безкоштовна доставка
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-147">
              Ми пропонуємо безкоштовну доставку Новою Поштою для всіх замовлень
              на суму понад 5000 ₴.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-148">
              Для замовлень від 5000 ₴
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-149">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-150">
              <Clock className="w-8 h-8 text-brand-burgundy" data-id="element-151" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-152">
              Міжнародна
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-153">
              Доступна доставка по всьому світу через Укрпошту. Терміни доставки
              залежать від країни призначення.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-154">
              14-30 Робочих днів
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}